'use strict';

require('unfetch/polyfill');

require('foundation-sites');

require('simplebar');

require('../utils/add-mobile-detect-body-classes');

require('../../styles/layout/theme.scss');

require('../utils/breakpoints');

require('../i18n/');

require('../utils/utm-cookie');

require('../apps/pdp-selected-variant');

require('../apps/account-v3/');

require('../apps/add-to-cart/');

require('../apps/bundler/');

require('../apps/essentials-bundler/');

require('../apps/cart/');

require('../apps/prebuilt-bundler');

require('../apps/product-details-store-locator');

require('../apps/tld-redirect-modal/');

require('../apps/ingredients/');

require('../apps/vitamin-bundler/');

require('../apps/new-mom-giveaway/');

require('../apps/night-time-diapers');

require('../apps/checkout');

require('../apps/image_modal');

require('../apps/faq');

require('../apps/magic-link');

require('../apps/press-page');

require('../apps/search');

require('../apps/variant-selector');

require('../apps/feature-tabs');

require('../apps/pdp-add-to-cart');

require('../apps/oos-signup');

require('../apps/announcement-bar');

require('../apps/login');

require('../apps/quick-add');

require('../apps/bundler-v2');

require('../plugins/accordion-menu/');

require('../plugins/drawer/');

require('../plugins/reveal');

require('../plugins/pdp-pattern-picker/');

require('../plugins/in-view/');

require('../sections/header');

require('../sections/header-mobile');

require('../sections/pdp-ingredients');

require('../utils/save-discount-for-checkout');

require('../utils/save-promo-code-for-checkout');

require('../utils/find-element-once-it-exists');

require('../apps/checkout/helpers/login_redirection');

require('../misc/show-content-only');